(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product-tab"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const tabLinks = document.querySelectorAll(
    '.product-details-reviews .review-tab a[data-toggle="tab"]'
  );
  const tabPanes = document.querySelectorAll(
    '.product-details-reviews .tab-content .tab-pane'
  );

  if (!tabLinks.length || !tabPanes.length) return;

  tabLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      // Remove active from all links
      tabLinks.forEach(function (l) {
        l.classList.remove('active');
        l.setAttribute('aria-selected', 'false');
      });

      // Hide all panes
      tabPanes.forEach(function (pane) {
        pane.classList.remove('show', 'active');
      });

      // Activate clicked tab
      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');

      // Show corresponding pane
      const targetSelector = this.getAttribute('href'); // e.g. "#product-dec"
      const targetPane = document.querySelector(targetSelector);
      if (targetPane) {
        targetPane.classList.add('show', 'active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
